module.exports = __webpack_public_path__ + "static/media/pc.dc37e752.svg";